import React from "react";
import styled from "styled-components";
import Link from "gatsby-link";
import baseStyles from "../styles/baseStyles";
import slugify from "slugify";
import ReactMarkdown from "react-markdown";
import MediaQuery from "react-responsive";

const Container = styled.div`
  max-width: 64rem;
  width: 100%;
  margin: auto;
  height: 100%;
  @media screen and (max-width: 64em) {
    width: calc(100vw - 4rem);
  }
  @media screen and (max-width: 20em) {
    width: calc(100vw - 2rem);
  }
`;

const MainWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  @media (max-width: 48em) {
    flex-direction: column;
  }
`;

const List = styled.ul`
  padding: 0;
  margin: 0;
  align-self: flex-start;
  top: 3rem;
  margin-right: 5rem;
  @media (max-width: 48em) {
    width: 100%;
    margin-bottom: 1rem;
  }
`;

const CategoryTitle = styled(Link)`
  font-family: Futura;
  color: rgba(37, 42, 43, 0.75);
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  transition: 0.2s all ease;
  text-decoration: none;
  cursor: pointer;
  :hover {
    color: ${baseStyles.color.primary};
  }
  &.active {
    color: ${baseStyles.color.primary};
  }
`;

const ArticleList = styled.ul`
  margin: 0.75rem 0;
  padding: 0;
  list-style: none;
  @media (max-width: 48em) {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    overflow-x: scroll;
  }
`;

const Article = styled.li`
  cursor: pointer;
  margin: 0.15rem 0;
  padding: 1rem;
`;

const ArticleTitle = styled(Link)`
  font-family: Lato;
  font-size: 15px;
  color: rgba(37, 42, 43, 0.75);
  letter-spacing: 1.33px;
  border-left: 3px solid transparent;
  transition: 0.2s all ease;
  text-decoration: none;
  white-space: nowrap;
  :hover {
    color: ${baseStyles.color.primary};
  }
  color: ${props => props.active && baseStyles.color.primary};
`;

const ContentArea = styled.div`
  background: white;
  border-radius: 5px;
  padding: 2rem 3rem;
  flex: 1;
  box-shadow: ${baseStyles.layers.l4};
  @media (max-width: 425px) {
    padding: 1rem 2rem;
  }
`;

const ArticleBody = styled(ReactMarkdown)`
  font-family: Lato;
  font-size: 1rem;
  color: rgba(37, 42, 43, 0.75);
  a {
    color: ${baseStyles.color.primary};
    text-decoration: none;
  }
`;

const AboutPage = props => {
  return (
    <Container>
      <MainWrapper>
        <List>
          <MediaQuery query="(min-width: 48em)">
            <CategoryTitle>About</CategoryTitle>
          </MediaQuery>
          <ArticleList>
            {props.data.pageTitles.edges.map(({ node: { pageTitle } }) => {
              const slug = `/about/${slugify(pageTitle, { lower: true })}`;
              return (
                <Article key={slug}>
                  <ArticleTitle
                    active={slug === props.pathContext.slug}
                    to={slug}
                  >
                    {pageTitle}
                  </ArticleTitle>
                </Article>
              );
            })}
          </ArticleList>
        </List>
        <ContentArea>
          <ArticleBody source={props.data.pageContent.content} />
        </ContentArea>
      </MainWrapper>
    </Container>
  );
};

export const AboutQuery = graphql`
  query getAllPages($id: String) {
    pageTitles: allAboutPage {
      edges {
        node {
          pageTitle
        }
      }
    }
    pageContent: aboutPage(id: { eq: $id }) {
      pageTitle
      content
    }
  }
`;

export default AboutPage;



// WEBPACK FOOTER //
// ./src/templates/AboutPage.js